import React, { useState, useEffect, useMemo } from "react";
import {
  Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow,Button,
  Paper, IconButton, InputBase, Pagination, Menu, MenuItem,CircularProgress
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import ExportDropdown from "../../../components/ExportDropdown";
import CustomText, { textStyles } from "../../../components/CustomText";
import StatusDropdown from "../../../components/StatusDropdown";
import RequestDetailsDrawer from "../Request/DetailsDrawer.js";
import { useTranslation } from "react-i18next";
import { showUnderDevelopment } from "../../../components/alerts.js";
import { useSelector } from "react-redux";
import { decryptToken } from "../../../Utlis/Encryption.js";
import { BASE_URL } from "../../../components/BaseUrl.js";
import TruncatedCell from "../../../components/TruncatedCell.js";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import emptypayment from "../../../assets/emptypayment.png";
import AddIcon from "@mui/icons-material/Add";
import {useLocation,useNavigate} from "react-router-dom";
import back from "../../../assets/back.svg";
import { pdf } from "@react-pdf/renderer";
import CustomButton from "../../../components/CustomButton.js";
import CancelRequestModal from "../Request/CancelRequest.js";
import {toast,Toaster} from "react-hot-toast";
import {useCompanyLogo} from "../../../components/FetchLogoPdf";
import mapicon from "../../../assets/Dashboard/mapicon.svg";
const HeaderStyles = {
  color: "#44546F",
  fontSize: "15px",
  fontWeight: 600,
  fontFamily: "Poppins, sans-serif",
  whiteSpace: "nowrap",
};

const DataStyles = {
  color: "#172B4D",
  fontSize: "13px",
  fontWeight: 400,
  fontFamily: "Poppins, sans-serif",
  whiteSpace: "nowrap",
};

const RequestManagement = () => {
  const { t } = useTranslation();

  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(false);
const [refreshList, setRefreshList] = useState(false);
const location = useLocation();
  const navigate = useNavigate();
  const fromDashboard = location.state?.fromDashboard;

  const rawEncryptedToken = localStorage.getItem("token");
  const token = rawEncryptedToken ? decryptToken(rawEncryptedToken) : null;
  const [search, setSearch] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const [menuRow, setMenuRow] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
const [initialLoading, setInitialLoading] = useState(true);   // full screen loader
const [tableLoading, setTableLoading] = useState(false); 
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
const { company } = useSelector((state) => state.auth);
const companyId = company?.id;
console.log(companyId)
const [filterOpen, setFilterOpen] = useState(false);
const [filters, setFilters] = useState({ status: "", startDate: "", endDate: "" });
const [addDrawerOpen, setAddDrawerOpen] = useState(false);
const pageSize = 5;

const fetchRequests = async (page = 1, limit = 5, isInitial = false, appliedFilters = filters) => {
  try {
    if (isInitial) setInitialLoading(true);
    else setTableLoading(true);

    const { status, startDate, endDate } = appliedFilters;
    let query = `no_pagination=true`;
    if (status) query += `&status=${status}`;
    if (startDate) query += `&start_date=${startDate}`;
    if (endDate) query += `&end_date=${endDate}`;
//     if (appliedFilters.startDate) filterQuery += `&from=${appliedFilters.startDate}`;
// if (appliedFilters.endDate) filterQuery += `&to=${appliedFilters.endDate}`;

    const res = await fetch(
      `${BASE_URL}/requests/v1/requests/my?${query}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
    const data = await res.json();
    setRequests(data.data || []);
  } catch (err) {
    console.error("Failed to fetch requests", err);
  } finally {
    setInitialLoading(false);
    setTableLoading(false);
  }
};


const [didMount, setDidMount] = useState(false);

useEffect(() => {
  fetchRequests(1, 5, true);   // first load with big loader
  setDidMount(true);
}, []);

useEffect(() => {
  if (didMount) {
    fetchRequests(1, 5);   // refetch data on list refresh
  }
}, [refreshList, didMount]);
  
const formatDateTime = (dateString) => {
  if (!dateString) return "-";
  const date = new Date(dateString);

  // Example: "11 Sept 2025"
  const formattedDate = date.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });

  // Example: "1:04 pm"
  const formattedTime = date.toLocaleTimeString("en-GB", {
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  });

  return `${formattedDate} - ${formattedTime}`;
};
const formatDateOnly = (dateString) => {
  if (!dateString) return "-";
  const date = new Date(dateString);
  if (Number.isNaN(date.getTime())) return "-";
  return date.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};

const formatTimeOnly = (timeString) => {
  if (!timeString) return "-";
  const time = new Date(timeString);
  if (Number.isNaN(time.getTime())) return "-";
  return time.toLocaleTimeString("en-GB", {
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  });
};

/** API stores ENUM-style values; table shows labels (e.g. SCHEDULE_CHANGE → Schedule Change). */
const formatRequestTypeLabel = (type) => {
  if (!type) return "-";
  const keyByType = {
    LEAVE: "options.leave",
    SCHEDULE_CHANGE: "options.scheduleChange",
    GENERIC_HR: "options.genericHR",
  };
  const i18nKey = keyByType[type];
  if (i18nKey) return t(i18nKey);
  return String(type)
    .split("_")
    .map((w) => w.charAt(0) + w.slice(1).toLowerCase())
    .join(" ");
};

/** Leave reason code enum → translated label. */
const formatReasonCodeLabel = (code) => {
  if (!code) return "-";
  const keyByCode = {
    URGENT: "options.leaveReasonCodes.urgent",
    SICK: "options.leaveReasonCodes.sick",
    VACATION: "options.leaveReasonCodes.vacation",
    OTHER: "options.leaveReasonCodes.others",
  };
  const i18nKey = keyByCode[code];
  return i18nKey ? t(i18nKey) : code;
};

const fetchAllRequests = async (token, filters = {}) => {
  try {
   let url = `${BASE_URL}/requests/v1/requests/my?no_pagination=true`;

    if (filters.status) url += `&status=${filters.status}`;
    if (filters.startDate) url += `&start_date=${filters.startDate}`;
    if (filters.endDate) url += `&end_date=${filters.endDate}`;

    const res = await fetch(url, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    const json = await res.json();

    if (json.error) {
      console.error("❌ Failed to fetch requests:", json.message);
      return [];
    }

    return (json.data || []).map((item) => ({
      id: item.id,
      type: formatRequestTypeLabel(item.type),
      reason: formatReasonCodeLabel(item.leave_reason_code),
      date: item.created_at
        ? new Date(item.created_at).toLocaleString("en-GB", {
            day: "2-digit",
            month: "short",
            year: "numeric",
            hour: "numeric",
            minute: "2-digit",
            hour12: true,
          })
        : "-",
      comments: item.admin_comment || "-",
      status: item.status || "-",
    }));
  } catch (err) {
    console.error("❌ Error fetching all requests:", err);
    return [];
  }
};
const { logo } = useCompanyLogo(token);
const filteredRequests = useMemo(() => {
  const lower = search.toLowerCase().trim();
  if (!lower) return requests;
  return requests.filter((row) => {
    const typeLabel = formatRequestTypeLabel(row.type).toLowerCase();
    return (
      row.type?.toLowerCase().includes(lower) ||
      typeLabel.includes(lower) ||
      row.leave_reason_text?.toLowerCase().includes(lower) ||
      row.status?.toLowerCase().includes(lower)
    );
  });
}, [search, requests, t]);

const totalPages = Math.max(1, Math.ceil(filteredRequests.length / pageSize));
const effectiveCurrentPage = Math.min(currentPage, totalPages);
const paginatedRequests = filteredRequests.slice(
  (effectiveCurrentPage - 1) * pageSize,
  effectiveCurrentPage * pageSize
);

useEffect(() => {
  setCurrentPage(1);
}, [search]);
const [cancelModalOpen, setCancelModalOpen] = useState(false);
const [cancelLoading, setCancelLoading] = useState(false);

// 👇 New for resubmit
const [resubmitModalOpen, setResubmitModalOpen] = useState(false);
const [resubmitLoading, setResubmitLoading] = useState(false);
const [uploadedFiles, setUploadedFiles] = useState([]); 
const handleCancelRequest = async (requestId) => {
  if (!requestId) return;
  try {
    setCancelLoading(true);

    const res = await fetch(`${BASE_URL}/requests/v1/requests/${requestId}/cancel`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    const data = await res.json();

    if (!res.ok) throw new Error(data.message || "Cancel failed");

    console.log("✅ Cancel Success:", data);

    setCancelModalOpen(false);
    setRefreshList((prev) => !prev); // refresh list
  } catch (err) {
    console.error("❌ Cancel Request Error:", err);
  } finally {
    setCancelLoading(false);
  }
};

const handleResubmitRequest = async (requestId, data) => {
  try {
    setResubmitLoading(true);
    const res = await fetch(`${BASE_URL}/requests/v1/requests/${requestId}/resubmit`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(data),
    });

    const json = await res.json();
    if (!res.ok) throw new Error(json.message || "Resubmit failed");

    toast.success("Request resubmitted successfully");
    setResubmitModalOpen(false);
    setRefreshList((prev) => !prev);
  } catch (err) {
    console.error("❌ Resubmit error:", err);
    toast.error(err.message || "Resubmit failed");
  } finally {
    setResubmitLoading(false);
  }
};

  const handleIcon = () => {
    navigate("/request-management", { state: { fromDashboard: true } });
}
  return (
    <>
                   {fromDashboard && (
      <Box
        sx={{
          border: '1px solid #E4E6EF',
          borderRadius: 2,
          px: 2,
          backgroundColor: 'white',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-start',
          minHeight: 55,
          mb: 2,
          ml:1, mr:1
        }}
      >
        <Box
          sx={{ display: 'flex', alignItems: 'center', gap: 1.5, cursor: 'pointer' }}
          onClick={() => navigate(-1)}
        >
          <img src={back} style={{ width: 30, height: 30 }} />
          <CustomText
            sx={{
              ...textStyles.h1,
              fontWeight: 500,
              fontSize: '14px',
              color: '#626F86',
              textAlign: 'center'
            }}
          >
            {t('worker')} 
          </CustomText>
        </Box>
      </Box>
    )}
    <Box sx={{ backgroundColor: "white", borderRadius: 2, border: "2px solid #091E4224", py: 2, px: 2, mt: 1, ml:1, mr:1 }}>
      
      {/* Header */}
      <Box
        sx={{
          pb: 2,
          borderBottom: "2px solid #091E4224",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          flexWrap: "wrap",
          gap: 2,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
  <CustomText
    sx={{ ...textStyles.h1, fontWeight: 600, fontSize: "18px", color: "#003149" }}
  >
    {t("requestManagement.heading")}
  </CustomText>
  {tableLoading && !initialLoading && (
    <CircularProgress size={20} />
  )}</Box>
        {/* Search */}
        <Box
          sx={{
            px: 1,
            py: 0.2,
            borderRadius: 1,
            height: 34,
            border: "2px solid #091E4224",
            display: "flex",
            alignItems: "center",
            minWidth: 250,
            maxWidth: 300,
          }}
        >
          <InputBase
            placeholder={t("search_request_by_type")}
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            sx={{
              fontSize: 14,
              fontFamily: "Poppins, sans-serif",
              color: "#939393",
              width: "100%",
            }}
          />
          <SearchIcon sx={{ fontSize: 20, color: "#888", ml: 1 }} />
        </Box>

        {/* Export & Filter */}
        <Box sx={{ display: "flex", flexDirection:"row",alignItems: "center", gap: 1 }}> 
 

                   <IconButton>
                   <img
                      src={mapicon}
                      onClick={handleIcon}
                      alt="map"
                      style={{ width: 33, height: 33 }}
                    />
                  </IconButton>
                    

        </Box>
      </Box>

      {/* Table */}
      <TableContainer component={Paper} sx={{ boxShadow: "none" }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell sx={HeaderStyles}>{t("requestManagement.tableHeaders.id")}</TableCell>
              <TableCell sx={HeaderStyles}>{t("requestManagement.tableHeaders.type")}</TableCell>
              <TableCell sx={HeaderStyles}>{t("requestManagement.tableHeaders.startDate")}</TableCell>
              <TableCell sx={HeaderStyles}>{t("requestManagement.tableHeaders.endDate")}</TableCell>
              <TableCell sx={HeaderStyles}>{t("requestManagement.tableHeaders.reasonCode")}</TableCell>
              <TableCell sx={HeaderStyles}>{t("requestManagement.tableHeaders.reasonDetails")}</TableCell>
              <TableCell sx={HeaderStyles}>{t("requestManagement.tableHeaders.date")}</TableCell>
              <TableCell sx={HeaderStyles}>{t("requestManagement.tableHeaders.comments")}</TableCell>
              <TableCell sx={HeaderStyles}>{t("requestManagement.tableHeaders.status")}</TableCell>
              <TableCell sx={HeaderStyles}>{t("requestManagement.tableHeaders.action")}</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {initialLoading ? (
              <TableRow>
                <TableCell colSpan={11} align="center"><CircularProgress size={40} /></TableCell>
              </TableRow>
            ) : filteredRequests.length  > 0 ? (
             paginatedRequests.map((row, i) => {
              let startDate = "-";
              let endDate = "-";
              let timeText = "-";
              let reasonCode = "-";
              let reasonDetails = "-";

              if (row.type === "LEAVE") {
                startDate = formatDateOnly(row.leave_start_date);
                endDate = formatDateOnly(row.leave_end_date);
                reasonCode = formatReasonCodeLabel(row.leave_reason_code);
                reasonDetails = row.leave_reason_text || "-";
              } else if (row.type === "SCHEDULE_CHANGE") {
                startDate = formatDateOnly(row.sched_effective_from);
                endDate = row.sched_current_days && Array.isArray(row.sched_current_days)
                  ? row.sched_current_days.join(", ")
                  : "-";
                if (row.sched_current_start_time && row.sched_current_end_time) {
                  timeText = `${formatTimeOnly(row.sched_current_start_time)} - ${formatTimeOnly(row.sched_current_end_time)}`;
                }
                reasonDetails = row.sched_reason_text || "-";
              } else if (row.type === "GENERIC_HR") {
                reasonDetails = row.details || "-";
              }

              return (
                <TableRow key={i}>
                  <TableCell sx={DataStyles}>{row.id}</TableCell>
                  <TableCell sx={DataStyles}>{formatRequestTypeLabel(row.type)}</TableCell>
                  <TableCell sx={DataStyles}>{startDate}</TableCell>
                  <TableCell sx={DataStyles}>{endDate}</TableCell>
                  <TableCell sx={DataStyles}>
                    {reasonCode}
                  </TableCell>
                  <TableCell sx={DataStyles}>
                    <TruncatedCell text={reasonDetails} />
                  </TableCell>
                  <TableCell sx={DataStyles}>
                    {formatDateTime(row.created_at)}
                  </TableCell>
                  <TableCell sx={DataStyles}>
                      <TruncatedCell text={row.admin_comment  || "-"}/>

                  </TableCell>
                  <TableCell sx={DataStyles}>
                    <Box sx={{ pointerEvents: "none" }}>
                      <StatusDropdown currentStatus={row.status} />
                    </Box>
                  </TableCell>
                  <TableCell>
                    <IconButton size="small"   onClick={(e) => {
    setAnchorEl(e.currentTarget);
    setMenuRow(row);   // ✅ store clicked row
  }}>
                      <MoreVertIcon fontSize="small" />
                    </IconButton>
                  </TableCell>
                </TableRow>
              );
            })
            ) : (
              <TableRow>
                <TableCell colSpan={11} align="center">            <Box
              sx={{
                flex: 1,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                py: 5,
              }}
            >
              <img
                src={emptypayment}
                alt="No Data"
                style={{ width: 200, marginBottom: 16 }}
              />
              <CustomText
                sx={{
                  ...textStyles.h1,
                  fontWeight: 500,
                  fontSize: "16px",
                  color: "#003149",
                }}
              >
                {t("empty.no_user")}
              </CustomText>
            </Box></TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Menu */}
      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={() => { setAnchorEl(null); setMenuRow(null); }}>
  <MenuItem
  onClick={() => {
    if (menuRow) {
      setSelectedRow(menuRow);   // save the full row
      setDrawerOpen(true);
    }
    setAnchorEl(null);
  }}
  sx={{ fontSize: 13, fontFamily: "Poppins, sans-serif" }}
>
  {t("unvalidatedPunches.tableActions.view")}
</MenuItem>

  {menuRow?.status?.toLowerCase() === "pending" && (
<MenuItem
  onClick={() => {
    setAnchorEl(null);
    setCancelModalOpen(true);
  }}
  sx={{
    fontSize: 13,
    fontFamily: "Poppins, sans-serif",
    color: "#d32f2f",
  }}
>
  {t("common.cancel") || "Cancel"}
</MenuItem>
  )}

{menuRow?.status?.toLowerCase() === "info_requested" && (
  <MenuItem
    onClick={() => {
      setAnchorEl(null);
      setResubmitModalOpen(true);
    }}
    sx={{
      fontSize: 13,
      fontFamily: "Poppins, sans-serif",
      color: "#006EC2",
    }}
  >
    {t("common.resubmit") || "Resubmit"}
  </MenuItem>
)}

      </Menu>

      {/* Pagination */}
      <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
        <Pagination
          count={totalPages}
          page={effectiveCurrentPage}
          onChange={(_, val) => setCurrentPage(val)}
          shape="rounded"
          color="primary"
          size="small"
                sx={{
                "& .MuiPaginationItem-root": {
                  fontFamily: "Poppins, sans-serif",
                  fontSize: 13,
                  fontWeight: 500,
                },
                "& .Mui-selected": {
                  backgroundColor: "#E9F3FF",
                  color: "#006EC2",
                },
              }}
        />
      </Box>

 <RequestDetailsDrawer
  open={drawerOpen}
  onClose={() => setDrawerOpen(false)}
  row={selectedRow}
    onStatusChanged={() => setRefreshList((prev) => !prev)}   // 👈 added
/> 



<CancelRequestModal
  open={cancelModalOpen}
  loading={cancelLoading}
  onClose={() => setCancelModalOpen(false)}
  onConfirm={() => handleCancelRequest(menuRow?.id)}
/>

<CancelRequestModal
  open={resubmitModalOpen}
  loading={resubmitLoading}
  mode="resubmit"
  token={token}
  requestType={menuRow?.type}   // 👈 auto-detects type from selected row
  onClose={() => setResubmitModalOpen(false)}
  onConfirm={(payload) => handleResubmitRequest(menuRow?.id, payload)}
/>

  </Box>
  </>
  );
};

export default RequestManagement;












